import { useState } from 'react';
import { Box, Button, TextField, Typography, Divider } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';

const ContactNumber = ({ form, setForm, setStatus, clearForm, customisations }) => {
   const [contactNumber, setContactNumber] = useState(() => {
      if (form?.contactNumber !== undefined) {
         return form.contactNumber;
      }
      return '';
   });

   async function saveContactNumber() {
      setForm({ ...form, contactNumber });
      setStatus('step2');
   }
   async function goBack() {
      if (customisations.carReg) {
         setStatus('carReg');
      } else {
         setStatus('step1');
      }
   }

   return (
      <Box sx={{ width: '100%' }}>
         <Typography variant="h5" align="center">
            Contact Number
         </Typography>
         <Typography variant="body1" align="center">
            Please add your contact number so your host can reach you if needed.
         </Typography>
         <Box
            sx={{
               display: 'flex',
               flexDirection: 'row',
               gap: 3,
               mb: 3,
               justifyContent: 'space-between',
               width: '100%',
               mt: 1,
            }}
         >
            <Box sx={{ width: '15%', mt: 2 }}>
               <Button
                  onClick={goBack}
                  sx={{ height: '130px' }}
                  fullWidth
                  variant="outlined"
                  color="primary"
               >
                  Back
               </Button>
            </Box>
            <Box sx={{ minWidth: '70%', flexDirection: 'column' }}>
               <TextField
                  value={contactNumber}
                  onChange={(e) => setContactNumber(e.target.value)}
                  label="Contact Number"
                  variant="outlined"
                  margin="normal"
                  fullWidth
               />
            </Box>

            <Box sx={{ width: '15%', mt: 2, display: 'flex', alignItems: 'flex-start' }}>
               <Button
                  onClick={saveContactNumber}
                  variant="contained"
                  fullWidth
                  sx={{ height: '130px' }}
                  color="primary"
               >
                  {contactNumber === '' ? 'Skip' : 'Next'}
               </Button>
            </Box>
         </Box>
         <Divider sx={{ width: '100%' }} />
         <Box sx={{ width: '100%', mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Button onClick={clearForm} startIcon={<ReplayIcon />} color="primary">
               Start again
            </Button>
         </Box>
      </Box>
   );
};

export default ContactNumber;
